import type { TreeMapProviderProps } from "./tree-map.type";

import TreeMap from "./tree-map.component";
import { TreeMapContext } from "./tree-map.context";
import { useTreeMapContextData } from "./tree-map.hook";

const TreeMapProvider = (props: TreeMapProviderProps) => {
  const data = useTreeMapContextData(props);

  return (
    <TreeMapContext.Provider value={data}>
      <TreeMap />
    </TreeMapContext.Provider>
  );
};

export default TreeMapProvider;
